import { useSearchParams } from 'react-router-dom';

export const useGetUrlParameter = (paramName) => {
  const [searchParams] = useSearchParams();
  const namedParam = searchParams.get(paramName);
  return namedParam ? `${paramName}=${encodeURIComponent(namedParam)}` : '';
};